// extracted by mini-css-extract-plugin
export var active = "styles-module--active--40799";
export var iconContainer = "styles-module--iconContainer--b6318";
export var item = "styles-module--item--43c99";
export var slot = "styles-module--slot--85bce";
export var tabBarContainer = "styles-module--tabBarContainer--43e0b";
export var text = "styles-module--text--66c4e";